<div class="mt-5 mt-lg-6 mb-3">
  <mwe-button-link (clicked)="onButtonClicked()" [label]="label()" dataTest="back-button" prependIconClass="fa fa-chevron-left" />
</div>
